import React from "react";
import ReportFirstIssue from "@/assets/NoResults.svg";

const NoResults = ({ desc }: { desc: string }) => {
  return (
    <div className="flex flex-col items-center absolute text-center top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%]">
      <img className="w-[154px] h-[154px]" src={ReportFirstIssue} />
      <div className="flex flex-col items-center px-[13px] pb-[32px]">
        <p className="mt-8 text-[20px] leading-[28px] font-medium">
          No results
        </p>
        <p className="w-[235px] text-gray-800 mt-3 text-[14px] leading-[20px] font-medium">
          {desc}
        </p>
      </div>
    </div>
  );
};

export default NoResults;
